import { Component, input } from '@angular/core';
import { FieldTree, FormField } from '@angular/forms/signals';
import { MatInputModule } from '@angular/material/input';
import { Buried } from './buried.model';


@Component({
  selector: 'app-buried',
  imports: [FormField, MatInputModule],
  templateUrl: './buried.component.html',
  styles: ``,
})
export class BuriedComponent {

  readonly form = input.required<FieldTree<Buried>>();

  ngOnDestroy() {

    if (!this.form().depth().valid())
      this.form().depth().value.set(0.9);

    if (!this.form().soilThermalResistivity().valid())
      this.form().soilThermalResistivity().value.set(1.2);
  }

}
